/**
 * 회사코드별 메뉴 설정
 * 
 * 새로운 회사코드 설정을 추가하려면:
 * 1. companies/ 디렉토리에 4자리 숫자.js 파일 생성 (예: 1000.js, 2000.js)
 * 2. 아래와 같이 import 및 COMPANY_CONFIGS 객체에 추가
 * 
 * 예시:
 * import config1000 from './1000';
 * 
 * export const COMPANY_CONFIGS = {
 *   '1000': config1000,
 *   // 다른 회사코드들...
 * };
 */

// 회사코드별 설정 import
// import config1000 from './1000';
import config2000 from './2000';
// import config2100 from './2100';
// import config2200 from './2200';
import config9999 from './9999';

// 회사코드별 설정 객체 (회사코드는 문자열로 저장: '1000', '2000' 등)
export const COMPANY_CONFIGS = {
  // '1000': config1000,
  '2000': config2000,
  // '2100': config2100,
  // '2200': config2200,
  '9999': config9999,
  // 새로운 회사코드 설정을 여기에 추가하세요
};

